// @mui
import { enUS, nlNL } from "@mui/material/locale"
import { enUS as en, nl } from "date-fns/locale"

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

const allLangs = [
  {
    label: "English",
    value: "en",
    systemValue: enUS,
    icon: "/assets/icons/flags/ic_flag_en.svg",
    dateLocales: en,
  },
  {
    label: "Nederlands",
    value: "nl",
    systemValue: nlNL,
    icon: "/assets/icons/flags/ic_flag_nl.svg",
    dateLocales: nl,
  },
]

export type LangsValuetype = (typeof allLangs)[number]["value"]

export default allLangs
